<template>
  <v-sheet>
    <v-card>
      <v-card-title v-text="label" />
      <v-card-text>
        <v-text-field
          v-model="modelValue.text"
          type="text"
          label="Texto"
          @change="update"
        />

        <v-text-field
          v-model="modelValue.url"
          type="url"
          label="URL"
          @change="update"
        />

        <v-select
          v-model="modelValue.target"
          label="Abrir em"
          :items="targetOptions"
          item-value="value"
          item-text="title"
          clearable
          @change="update"
        />

        <v-checkbox
          v-model="modelValue.nofollow"
          label="No follow"
          @change="update"
        />

        <v-checkbox
          v-model="modelValue.noindex"
          label="No index"
          @change="update"
        />
      </v-card-text>
    </v-card>
  </v-sheet>
</template>

<script>
  import targetOptions from '@/helpers/targetOptions'

  export default {
    name: 'LinkInput',
    props: {
      value: {
        type: Object,
        required: true,
      },
      label: {
        type: String,
        default: 'Conteúdo',
      },
      error: {
        type: String,
        required: false,
      },
    },
    emits: ['input'],
    data: function () {
      return {
        targetOptions,
        modelValue: {
          text: '',
          url: '',
          target: '',
          nofollow: false,
          noindex: false,
        },
      }
    },
    mounted: function () {
      this.modelValue = this.value

      const fields = ['text', 'url', 'target', 'nofollow', 'noindex']

      fields.forEach(field => {
        if (this.modelValue[field] === undefined) {
          this.modelValue[field] = null
        }
      })
    },
    methods: {
      update: function () {
        this.$emit('input', this.modelValue)
      },
    },
  }
</script>
